module.exports = __webpack_public_path__ + "img/nonwood_grey_al.556426e5.svg";